declare global {
  interface Window {
    OneTrust?: {
      OnConsentChanged: (handler: () => void) => void;
    };
  }
}

export const setupConsentChangedListener = (
  consentChangedHandler: () => void,
) => {
  if (!window.OneTrust) {
    window.addEventListener("OneTrustReady", () => {
      window.OneTrust?.OnConsentChanged(consentChangedHandler);
    });
  } else {
    window.OneTrust.OnConsentChanged(consentChangedHandler);
  }
};
